import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllBatchReleaseService = async (
  pageNumber,
  pageSize,
  access_token,
  searchedDepot = "",
  userId
) => {
  try {
    return axios.get(
      `${api}/BatchReleaseApproval/GetBatchReleaseApprovalData?UserId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const updateBatchApprovalStatus = async (access_token, data, userId) => {
  try {
    return axios.post(
      `${api}/BatchReleaseApproval/ApproveReleasedDrugs?Approver_Id=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};
